import { EventEmitter } from "@angular/core";
import {
  DynamcColumnComponent,
  ButtonDownloadCheckComponent,
  ColorRowTableComponent,
  ButtonsActionsTableComponent,
  ButtonPreviewDocCheckComponent
} from "@app/shared";
import { ButtonViewFlowComponent } from "@app/shared/component-table/button-view-flow.component";

export class FlowConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};
  // configuración de la tabla para búsqueda por proceso
  settingsProcess = {};

  constructor(data?: any, object?: any) {
    const self = this;
    var accents = require('remove-accents');
    if (data) {
      if (object && object.envio_servicio) {
        this.settingsProcess = {
          mode: "external",
          selectMode: 'multi',
          noDataMessage: "Actualmente no hay información para mostrar",
          actions: false,
          attr: {
            class: "table-bordered table-hover",
          },
          columns: {},
        };
      } else {
        this.settingsProcess = {
          mode: "external",
          noDataMessage: "Actualmente no hay información para mostrar",
          actions: false,
          attr: {
            class: "table-bordered table-hover",
          },
          columns: {},
        };
      }
      // this.settingsProcess = {
      //   mode: "external",
      //   selectMode: 'multi',
      //   noDataMessage: "Actualmente no hay información para mostrar",
      //   actions: false,
      //   attr: {
      //     class: "table-bordered table-hover",
      //   },
      //   columns: {},
      // };
      data.forEach((s: any) => {
        let renderComponent = null;
        if (s.tipo_estructura.nombre == "documento" || s.tipo_estructura.nombre == "documento_anexo") {
          renderComponent = ButtonDownloadCheckComponent;
        }else if(s.tipo_estructura.nombre == "preview_documento" ){
          renderComponent = ButtonPreviewDocCheckComponent;
        }
        let column: any = {};
        column[s.alias] = "";


        if(s.propiedades && s.propiedades.tipo && s.propiedades.tipo == 'determinar_color'){
          renderComponent = ColorRowTableComponent
          column[s.alias] = {
            title: s.label,
            editable: false,
            type: "custom",
            filter: false,
            renderComponent: renderComponent,
          };
        }
        
        if ((s.tipo_estructura.nombre == "documento" || s.tipo_estructura.nombre == "documento_anexo") && !(s.propiedades && s.propiedades.tipo && s.propiedades.tipo == 'determinar_color') ) {
          column[s.alias] = {
            title: s.label,
            editable: false,
            type: "custom",
            filter: { inputClass: "form-control" },
            renderComponent: renderComponent,
            onComponentInitFunction(instance: any) {
              instance.save.subscribe((data: any) => {
                // controla el evento click del boton
                const sendData = {
                  action: "descargar",
                  data: data,
                  type_document: s.tipo_estructura.nombre
                };
                self.accion.emit(sendData);
              });
            },
          };
        }else if (s.tipo_estructura.nombre == "preview_documento"  && !(s.propiedades && s.propiedades.tipo && s.propiedades.tipo == 'determinar_color') ) {
          column[s.alias] = {
            title: s.label,
            editable: false,
            type: "custom",
            filter: { inputClass: "form-control" },
            renderComponent: renderComponent,
            onComponentInitFunction(instance: any) {
              instance.save.subscribe((data: any) => {
                // controla el evento click del boton
                const sendData = {
                  action: "preview_documento",
                  data: data,
                  type_document: s.tipo_estructura.nombre
                };
                self.accion.emit(sendData);
              });
            },
          };
        }
        
        else if(!(s.propiedades && s.propiedades.tipo && s.propiedades.tipo == 'determinar_color')){
          column[s.alias] = {
            title: s.label,
            editable: false,
            filter: { inputClass: "form-control" },
            filterFunction: (cell?: any, search?: string) => {
              if (cell){
                if(typeof(cell) == 'string'){
                  return accents.remove(cell.toLowerCase()).includes(accents.remove(search.toLowerCase())) ? true : false;
                }else{
                  return cell.toString().includes(search) ? true : false;
                } 
              }else{
                return false;
              }
            }
          };
        }
        this.settingsProcess["columns"][s.alias] = "";
        this.settingsProcess["columns"][s.alias] = column[s.alias];
      });
      if (data.length) {
        if (object && object.envio_servicio == true) {
          let selectChec;
          let acciones;
          selectChec = {
            alias: 'seleccionar',
            label: 'Seleccionar',
            orden: 5,
            propiedades: null,
            tipo_estructura: {
              id: 1,
              nombre: ''
            },
          };
    
          acciones = {
            alias: 'acciones',
            label: 'Acciones',
            orden: 6,
            propiedades: null,
            tipo_estructura: {
              id: 1,
              nombre: 'texto'
            },
            renderComponent: ButtonsActionsTableComponent,
            onComponentInitFunction(instance: any) {
              instance.viewDetail = true;
              instance.save.subscribe((data: any) => {
                // controla el evento click del boton
                self.accion.emit(data);
              });
            }
          }

          let renderComponent = null;
          renderComponent = ButtonViewFlowComponent;

          this.settingsProcess["columns"]["_btnVer"] = {
            title: 'Ver',
            editable: false,
            type: "custom",
            filter: { inputClass: "form-control" },
            renderComponent: renderComponent,
            onComponentInitFunction(instance: any) {
              instance.save.subscribe((data: any) => {
                // controla el evento click del boton
                
                const sendData = {
                  action: "ver_flujo",
                  data: data,
                  type_document: ''
                };
                self.accion.emit(sendData);
                // getInstance(data)
              });
            },
          };

        }
      }
    }

    this.settings = {
      mode: "external",
      noDataMessage: "Actualmente no hay trámites iniciados",
      actions: false,
      attr: {
        class: "table-bordered table-hover",
      },
      columns: {
        idExpediente: {
          title: "Consecutivo sistema",
          editable: false,
          filter: {
            inputClass: "form-control",
          },
        },
        radicadoSolicitud: {
          title: "Radicado solicitud",
          editable: false,
          filter: {
            inputClass: "form-control",
          },
        },
        radicadoExpediente: {
          title: "Expediente",
          editable: false,
          filter: {
            inputClass: "form-control",
          },
        },
        estadoNombre: {
          title: "Estado expediente",
          editable: false,
          sort: true,
          filter: {
            inputClass: "form-control",
          },
          // type: 'custom',
          // renderComponent: StatusTramiteComponent,
        },
      },
    };
  }

  /**
   * Genera las columnas dinamicas del calendario de actividades
   *
   * @param {string} key
   * @param {string} title
   * @memberof FlowConfig
   */
  generateColumn(key: string, title: string) {
    this.settings["columns"][key] = {
      title: title,
      editable: false,
      type: "custom",
      renderComponent: DynamcColumnComponent,
      onComponentInitFunction() {},
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/flow/shared/flow.config.service.ts